import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53860f44"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "answerList"
}
const _hoisted_4 = {
  key: 3,
  class: "answerList"
}
const _hoisted_5 = {
  key: 4,
  class: "btns"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("上一题")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("下一题")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "contentView",
    style: _normalizeStyle(`font-size: ${_ctx.fontSize}px`)
  }, [
    (_ctx.examData.quType)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.examData?.sort + 1) + "." + _toDisplayString(_ctx.examData.content), 1))
      : _createCommentVNode("", true),
    (_ctx.examData.image!=null && _ctx.examData.image!='')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createVNode(_component_el_image, {
            src: _ctx.examData.image,
            style: {"max-width":"800px"}
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.examData.quType === 1 || _ctx.examData.quType===3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examData.answerList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              style: {"padding-left":"20px"}
            }, [
              _createVNode(_component_el_checkbox, {
                modelValue: item.checked,
                "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                size: "large",
                onChange: ($event: any) => (_ctx.radioChange($event,index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.abc + '.'+ item.content), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.examData.quType === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examData.answerList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              style: {"padding-left":"20px"}
            }, [
              _createVNode(_component_el_checkbox, {
                modelValue: item.checked,
                "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                size: "large",
                onChange: ($event: any) => (_ctx.checkBoxChange($event,index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.abc + '.'+ item.content), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.examData.quType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.questionData.isStart)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: _ctx.handPrevious
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.questionData.isEnd)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                onClick: _ctx.handNext
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 4))
}